let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6S8Ci")).then(() => parcelRequire('alTkB'));